import script from "./v-grid.vue?vue&type=script&lang=js"
export * from "./v-grid.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__